/** ShiftQuote logo mark — uses the actual app icon image.
 *  Drop-in replacement for the SVG monogram in the Navbar logo box. */
export function BrandMark({ className = "w-5 h-5" }) {
  return (
    <img
      src="/logo192.png"
      alt="ShiftQuote"
      className={className}
      style={{ objectFit: "contain" }}
    />
  );
}
